<script lang="ts">
    import SeoMeta from "$lib/components/SeoMeta.svelte";
</script>

<SeoMeta
    title="Privacy Policy - Data Handling and Cookies"
    description="OverwatchBrain privacy policy. Learn how we handle your data, what cookies we use, and our approach to analytics and user privacy."
    path="/privacy-policy"
/>

<div class="prose prose-invert mx-auto max-w-3xl px-4 py-10">
    <h1>Privacy Policy</h1>
    <p>Last updated: March 20, 2026</p>

    <h2>Overview</h2>
    <p>
        OverwatchBrain is a static website that displays Overwatch hero statistics and tier lists. We take your privacy
        seriously and collect minimal data.
    </p>

    <h2>Data Collection</h2>
    <p>
        We do not require user accounts or collect personal information directly. Our site may use third-party services
        for analytics and advertising that may collect anonymous usage data through cookies.
    </p>

    <h2>Third-Party Services</h2>
    <ul>
        <li>
            <strong>Playwire</strong> — All or partial advertising on this Website or App is managed by Playwire LLC. If
            Playwire publisher advertising services are used, Playwire LLC may collect and use certain aggregated and
            anonymized data for advertising purposes. To learn more about the types of data collected, how data is used
            and your choices as a user, please visit
            <a href="https://www.playwire.com/privacy-policy">https://www.playwire.com/privacy-policy</a>.
        </li>
        <li>
            <strong>Google Analytics</strong> — Uses cookies to collect anonymous usage data such as page views, session
            duration, and traffic sources. You can opt out at
            <a href="https://tools.google.com/dlpage/gaoptout">Google Analytics Opt-out</a>.
        </li>
        <li><strong>Cloudflare</strong> — Provides hosting and may collect basic analytics.</li>
    </ul>

    <h2>Your Rights</h2>
    <p>
        Under CCPA, California residents may opt out of the sale of personal information. Under GDPR, EU residents have
        the right to access, correct, or delete their data.
    </p>
    <p>To exercise these rights or ask questions, contact us.</p>

    <h2>Data Sources</h2>
    <p>
        Hero statistics displayed on this site are sourced from Blizzard Entertainment's official public statistics
        page. All Overwatch-related content and trademarks are property of Blizzard Entertainment.
    </p>
</div>
